import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../services.css'

const ios = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/apple.svg"
const android = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/android.svg"
const frontEnd = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/code-tag.svg"
const backEnd = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/algorithm.svg"
const cloud = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/brainstorm.svg"
const blockchain = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/cube.svg"
const ai = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/knowledge.svg"
const devops = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/service-home/share.svg"

const products = [
  {
    imgSrc: ios,
    imgAlt: 'apple',
    title: 'Hire An IOS Developer',
    link: '/services/hire_ios_developer',
    subText: 'Learn How',
  },
  {
    imgSrc: android,
    imgAlt: 'android',
    title: 'Hire An Android Developer',
    link: '/services/hire_android_developer',
    subText: 'Learn How',
  },
  {
    imgSrc: frontEnd,
    imgAlt: 'code',
    title: 'Hire A Front End Developer',
    link: '/services/hire_reactjs_developer',
    subText: 'Learn How',
  },
  {
    imgSrc: backEnd,
    imgAlt: 'algorithm',
    title: 'Hire A Back End Developer',
    link: '/services/hire_Nodejs_developer',
    subText: 'Learn How',
  },
  {
    imgSrc: cloud,
    imgAlt: 'brainstorm',
    title: 'Hire A Cloud Architect',
    link: '/services/hire_AWS_Cloud_developer',
    subText: 'Learn How',
  },
  {
    imgSrc: blockchain,
    imgAlt: '3d',
    title: 'Hire A Blockchain Developer',
    link: '/services/hire_blockchain_developer',
    subText: 'Learn How',
  },
  {
    imgSrc: ai,
    imgAlt: 'knowledge',
    title: 'Hire An AI/ML Developer',
    link: '/services/hire_ml_engineer',
    subText: 'Learn How',
  },
  {
    imgSrc: devops,
    imgAlt: 'share',
    title: 'Hire A DevOps Professional',
    link: '/services/hire_devops_engineer',
    subText: 'Learn How',
  },
];

const HireTeamCards = () => {
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <h3 className="text-primary text-center mb-3 ft-wt-700">
            Apply For A FREE 2-Week Trial
          </h3>
        </Col>
      </Row>
      <Row>
        {products.map((product, index) => (
          <Col xs={12} md={4} lg={3} key={index} className="mb-3">
            <Link to={product.link}>
              <Card className="product-card">
                <Card.Body className="text-center">
                  <img
                    className="mb-4"
                    src={product.imgSrc}
                    alt={product.imgAlt}
                  />
                  <p className="text-primary ft-wt-700">
                    <Link to={product.link}>{product.title}</Link>
                  </p>
                  <h6 className="mb-0 mt-auto">
                    <Link to={product.link}>{product.subText}</Link>
                  </h6>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default HireTeamCards;
